import _, {isEmpty} from "lodash";
import {useEffect, useState} from "react";
import API from "../app/api";

export default function useDict(dictType, sort = '', filter = '') {
    const controller = new AbortController();

    const [dict, setDict] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        let sortFiled;
        let filterReq = '';
        let urlEndpoint = '';
        if (dictType) {
            if (dictType.toLowerCase() === "consultants"){
                urlEndpoint = '/consultants';
                sortFiled = `$sort=${!isEmpty(sort) ? sort : 'familyName'}`;
            } else if (dictType.toLowerCase() === "hospitals"){
                urlEndpoint = '/hospitals';
                sortFiled = `$sort=${!isEmpty(sort) ? sort : 'description'}`;
            } else {
                urlEndpoint = `/$dict/${dictType}`;
                sortFiled = `$sort=${!isEmpty(sort) ? sort : 'description'}`;
            }
            if (!isEmpty(filter)) {
                filterReq = `$filter=${filter}`;
                urlEndpoint = `${urlEndpoint}?${filterReq}&${sortFiled}`;
            } else {
                urlEndpoint = `${urlEndpoint}?${sortFiled}`;
            }

            setLoading(true);
            //API.getDictByURL(`/$dict/${dictType}?${filterReq}${sortFiled}`, controller.signal)
            API.getDictByURL(`${urlEndpoint}`, controller.signal)
                .then(dictData => {
                    if (!_.isEmpty(dictData?.__data)) {
                        setDict(dictData?.__data);
                    }
                }).finally(() => setLoading(false));
        }
        return () => {
            controller.abort();
        };
    }, []);

    return [dict, loading];
}